// extracted by mini-css-extract-plugin
module.exports = {"localityDirectoryContainer":"LocalityDirectoryTemplate_localityDirectoryContainer__cyaiw"};